/*
 * @Author: wzh
 * @LastEditTime: 2023-07-03 16:08:38
 * @Description: 国际化 中文
 */
export default {
  // 公共
  base: {
    idCard: "身份证",
    passport: "护照",
    gatCard: "港澳台身份证",
    other: "其他",
    input: "请输入",
    select: "请选择",
    // 邮箱
    email: {
      label: "邮箱",
      placeholder: "请输入邮箱",
      error_tip: "请输入正确的邮箱",
    },
    // 手机号
    mobile: {
      label: "手机号",
      placeholder: "请输入手机号",
      error_tip: "请输入正确的手机号",
      china: "中国大陆",
    },
    // 密保问题
    question: {
      label: "问题",
      question_placeholder: "请选择问题",
      placeholder: "请输入答案",
      answer: "答案",
      not_set: "未设置密保问题",
      error_tip: "填写内容有误，请检查！",
    },
    // 验证码
    captcha: {
      label: "验证码",
      placeholder: "请输入验证码",
      img_placeholder: "请输入图片中的字符",
      message_placeholder: "请输入短信验证码",
    },
    // 按钮
    btn: {
      get_code: "获取验证码",
      next_step: "下一步",
      sure: "确定",
      reset: "重置",
      submit: "提交",
      save: "保存",
      back_login: "返回登录",
      continue_login: "继续登录",
      pass: "跳过",
      logout: "退出登录",
      bind: "绑定",
      unbind: "解绑",
      change: "更改",
    },
    // 密码
    password: {
      tip: "忘记密码？",
      old: "旧密码",
      old_placeholder: "请输入旧密码",
      new: "新密码",
      new_placeholder: "请输入新密码",
      new_confirm: "确认新密码",
      new_confirm_placeholder: "请输入确认新密码",
      strength: "密码强度",
      strength_weak: "弱",
      strength_medium: "中",
      strength_strong: "强",
      format_error: "不可包含中文字符、汉字、空格",
      again_error: "两次密码输入不一致",
      capital: "大写字母",
      lowercase: "小写字母",
      number: "数字",
      character: "特殊字符",
      length_tip: "最少输入字符数",
      includes_tip: "且包含",
      least_includes_tip: "至少包含大写字母、小写字母、数字、特殊字符中的种类数",
      must_includes_tip: "必须包含",
      weak_password: "弱密码",
      medium_password: "中密码",
      strong_password: "强密码",
      update_password: "修改密码",
      init_error: "密码初始化后首次登录必须修改，继续登录前您需要修改密码",
      overtime_error: "您的密码已使用了$xxx天，为了保障信息安全，请修改您的密码",
      strength_error: "您的密码强度不符合系统要求，请按照要求重新设置密码",
      update_alert: "新密码强度最低为：",
      update_error: "新密码强度不符合要求！",
    },
    // 提示语
    prompt: {
      confirm_title: "提示",
      login_out: "确认退出登录吗？",
      unbind: '确定解绑"$xxx"该账户吗？',
      unbind_success_tip: "解绑成功",
      unbind_failure_tip: "解绑失败",
    },
    // 标点符号
    punctuation: {
      colon: ":",
      comma: ",",
      full_stop: ".",
      semicolon: ";",
      bracket_left: "(",
      bracket_right: ")",
    },
    // 表格
    table: {
      action: "操作",
      account: "账号",
      ip: "客户端IP",
      ip_location: "登录地点",
    },
  },
  // 登录页
  login: {
    title: "Unified identity authentication",
    type_account: "账号密码登录",
    type_phone: "手机快捷登录",
    username_placeholder: "请输入账号",
    password_placeholder: "请输入密码",
    no_login: "7天内免登录",
    online_help: "在线帮助",
    account_activation: "账号激活",
    forget_password: "忘记密码",
    login_btn: "登录",
    type_scan: "扫码登录",
    scan_tips: "扫码免验证，登录更安全",
    scan_app_left: "打开",
    scan_app_name: "钉钉",
    scan_app_right: "，扫描二维码",
    type_password: "密码登录",
    // 滑块
    verify: {
      tips: "拖动下方滑块完成拼图安全验证",
      success: "验证成功",
      error: "验证失败",
    },
    // 在线帮助
    help: {
      download: "下载",
      filename: "帮助文档",
    },
    // 账号激活
    activate: {
      step_one: "信息校验",
      step_two: "激活方式",
      step_three: "设置密码",
      step_four: "激活完成",
      offer_placeholder: "录取通知书号",
      name_placeholder: "请输入姓名",
      card_type_placeholder: "请选择证件类型",
      card_id: "请输入证件号码",
      account: "设置帐号",
      success: "账号激活成功！",
      go: "去登录",
      go_auto: "正在前往",
      irrelevant: "与当前激活账号无绑定关系，不可用于激活！",
    },
    // 忘记密码
    forget: {
      step_one: "输入帐号",
      step_two: "安全验证",
      step_three: "设置密码",
      step_four: "找回成功",
      safe_title: "您可以通过以下方式进行信息校验",
      safe_tip: "如果没有绑定邮箱、手机或预设问题，请联系管理员人工找回密码",
      safe_phone: "手机号验证",
      safe_email: "邮箱验证",
      safe_question: "问题验证",
      success: "密码找回成功！",
      no_question: "未设置密码问题，请用其他方式验证！",
    },
    // 用户信息防遗忘
    forgotten: {
      title: "用户信息防遗忘",
    },
    // 账户解休眠
    unsleep: {
      title: "账户解休眠",
      account: "账号",
      accountPlaceholder: "请输入账号",
      password: "密码",
      passwordPlaceholder: "请输入密码",
      username: "姓名",
      usernamePlaceholder: "请输入姓名",
      idCard: "身份证号",
      idCardPlaceholder: "请输入身份证号"
    },
    // 完善资料
    perfect_info: {
      title: "完善资料",
      tip: "您的资料不够完善，请在登录前补充完整个人资料。",
      birth_label: "生日",
      birth_placeholder: "请选择生日",
    },
    // 二次认证
    second_auth: {
      title: "二次认证",
      tip: "该系统需要进行用户身份的二次确认。",
      label: "认证方式",
      placeholder: "请选择认证方式",
      password_label: "密码",
      password_placeholder: "请输入密码",
      auth_list: {
        one: "短信验证码",
        two: "企业微信动态码",
        three: "支付宝人脸识别",
        four: "重新输入密码",
        five: "邮件验证码",
      },
    },
    // 单处登录
    simply_login: {
      tip: "该账号已在其他地址登录，继续登录会使对方自动下线。",
    },
  },
  // 首页
  home: {
    title: "统一身份认证平台",
    welcome: "欢迎您，",
    // 路由菜单
    route_menus: {
      my_app: "我的应用",
      account_safe: "账号安全",
      account_set: "账号设置",
      account_third: "第三方账户",
      account_related: "关联账号",
      social_login: "社交账号绑定",
      certify_record: "认证记录",
      current_login: "当前登录",
      account_certify: "账号认证",
      password_action: "密码维护",
      account_action: "账号维护",
      app_action: "应用访问",
      personal_data: "个人资料",
      love_set: "偏好设置",
    },
    // 我的应用
    my_app: {
      title: "在线应用",
      not_app: "暂无可用应用",
      tip: "应用维护中！",
    },
    // 账号设置
    account_set: {
      password: "登录密码",
      password_tip: "定期修改密码，可以提高您帐户的安全度",
      password_btn: "更换密码",
      question: "安全问题",
      question_tip: "设置安全问题，方便找回",
      question_btn_edit: "修改设置",
      question_btn_add: "立即设置",
      alias: "登录别名",
      alias_tip: "设置登录别名后，你可以使用别名登录系统",
      alias_btn_edit: "修改别名",
      alias_btn_add: "立即设置",
      alias_placeholder: "请输入您的登录别名",
      alias_tooltip: "支持设置多个别名以英文逗号分隔，可输入字母或数字。",
      alias_error: "输入格式有误",
      email: "邮箱绑定",
      email_tip: "绑定邮箱后，可以提高您帐户的安全度",
      email_btn_edit: "修改绑定",
      email_btn_add: "修改绑定",
      mobile: "手机号绑定",
      mobile_tip: "绑定手机后，可以提高您帐户的安全度",
      mobile_btn_edit: "修改绑定",
      mobile_btn_add: "立即绑定",
    },
    // 第三方账户
    account_third: {
      btn: "解除绑定",
      unbind_tip: "是否确认解绑？",
      columns: {
        app_name: "应用名称",
        bind_time: "绑定时间",
      },
    },
    // 关联账户
    account_related: {
      btn: "设为默认",
      columns: {
        create_time: "创建时间",
        user_type: "身份分类",
        common_user: "默认帐户",
      },
    },
    // 当前登录
    current_login: {
      current: "当前登录",
      logon_free: "免登录",
      columns: {
        login_time: "登录时间",
        browser: "客户端类型",
      },
    },
    // 账号认证
    account_certify: {
      title: "账号认证",
      date_search: "查询日期",
      type_search: "全部认证类型",
      type_one: "账号密码登录",
      type_two: "免登录",
      type_three: "jwt登录",
      type_four: "社交账号登录",
      result_search: "全部认证结果",
      result_success: "成功",
      result_failure: "失败",
      columns: {
        login_time: "登录时间",
        logout_time: "退出时间",
        login_type: "认证类型",
        result: "认证结果",
      },
    },
    // 密码维护
    password_action: {
      title: "密码维护记录",
      action_search: "全部操作类型",
      action_one: "新增",
      action_two: "修改",
      action_three: "删除",
      result_search: "全部操作结果",
      columns: {
        execute_time: "维护时间",
        action_type: "操作类型",
        result: "操作结果",
      },
    },
    // 账号维护
    account_action: {
      title: "账号维护",
    },
    // 应用访问
    app_action: {
      title: "应用访问记录",
      app_search: "请选择应用",
      result_search: "全部认证结果",
      columns: {
        access_time: "访问时间",
        app_name: "应用名称",
        result: "认证结果",
      },
    },
    // 个人资料
    personal_data: {
      title: "基本信息",
      head_picture_tip: "注：图片为无遮挡的正脸半身照，分辨率长宽均大于500，大小不超过4M，支持jpg/jpeg格式",
      username: "用户名",
      sex: "性别",
      sex_man: "男",
      sex_woman: "女",
      name: "姓名",
      birth: "出生日期",
      mobile: "手机号",
      email: "邮箱",
      id_type: "身份证件类型",
      id_card_no: "身份证件号",
      org: "所属组织",
      user_type: "身份分类",
      qq: "QQ号",
      address: "地址",
      fold_up: "收起更多",
      fold_down: "展开更多",
      title_user: "账号信息",
      status: "帐号状态",
      status_common: "正常",
      status_lock: "锁定",
      status_file: "归档",
      status_dormant: "休眠",
      status_freeze: "冻结",
      user_state: "激活状态",
      state_activate: "激活",
      state_inactive: "未激活",
      password_strength: "密码强度等级",
      activate_time: "激活日期",
      user_life: "帐号生命周期",
      user_life_end: "生命周期到期时间",
      alias: "别名",
      title_student_status: "学籍信息",
      school: "学校",
      college: "院系",
      major: "专业",
      grade: "当前所在年级",
      class: "班级",
      school_status: "学籍状态",
      entry_year: "入学年份",
      graduate_time: "毕业时间",
      offer_card_no: "录取通知书号",
      success_tip: "个人资料修改成功",
    },
    // 偏好设置
    love_set: {
      second_auth_set: "二次认证设置",
      second_auth_app: "可选的二次认证系统",
      not_app: "暂无可选的二次认证系统",
      other_set: "其他设置",
      single_login: "单处登录（只能在一个浏览器上登录，只保留最新登录页面，其余将退出登录）",
      password_change: "您的密码有变动时将使用以下方式提醒：短信和邮箱",
      save_success: "保存成功",
    },
  },

  // 移动端
  webapp: {
    // 登录页
    login: {
      welcome: "欢迎登录",
      // 完善资料
      perfect_info: {
        chose_birth: "选择生日",
      },
    },
    // 激活
    activate: {
      type_email: "邮箱激活",
      type_mobile: "手机号激活",
      account: "账号",
      name: "姓名",
    },
    // 忘记密码
    forget: {
      username: "用户名",
      username_placeholder: "请输入用户名",
      birth: "出生日期",
      birth_placeholder: "请选择出生日期",
      type_mobile: "手机号找回密码",
      type_email: "邮箱找回密码",
      type_question: "安全问题找回密码",
    },
    // 首页
    home: {
      edit_alias: "修改别名",
      update_password: "修改密码",
      bind_mobile: "手机绑定",
      bind_email: "邮箱绑定",
      bind_account: "身份绑定",
      bind: {
        account: "绑定账号和密码",
        no_app: "暂无绑定的应用",
        account_success: "绑定成功",
        common_user: "默认账户",
        bind_user: "已绑定账户",
        no_user: "无绑定账号",
        chose_user: "选择默认账户",
        change_user: "更改默认账户",
        bind_user_tip: "请绑定账户",
        alias: "登录别名",
        alias_placeholder: "支持设置多个别名以英文逗号分隔，可输入字母或数字。",
        alias_error: "输入格式有误",
        bind_success: "绑定成功，即将返回首页",
      },
    },
    // 密码
    password: {
      set_tip: "当前账号：",
      set_success: "密码设置成功",
      set_failure: "密码设置失败",
      auto_tip: "跳转登录页",
    },
    // 菜单
    menus: {
      perfect_info: "完善资料",
      forgotten: "信息防遗忘",
      second_auth: "二次认证",
      update_password: "修改密码",
      unsleep: "账户解休眠",
      simply_login: "单处登录",
      problem: "安全问题找回密码",
      authentication: "实人认证",
      bind_phone: "绑定手机号",
      activate_phone: "手机号激活",
      forget_phone: "手机号找回密码",
      bind_email: "绑定邮箱",
      activate_email: "邮箱激活",
      forget_email: "邮箱找回密码",
      new_password: "设置新密码",
      warn_password: "设置密码",
      forget_way: "选择找回密码方式",
      verify_info: "校验个人信息",
      activate_way: "选择激活账号方式",
      verify_info_activate: "校验个人信息",
      update_alias: "修改别名",
      bind_identity: "绑定身份",
    },
  },
};
